import { createApp } from 'vue'
import options from './ContactBanner.options'

const el = '.kb-component--contact-banner'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ContactBanner) => {
            if (ContactBanner.hasAttribute('data-v-app')) return false
            const component = createApp(options).use(Store)
            component.mount(ContactBanner)
        })
    }
}
